import { render, staticRenderFns } from "./ChatAppBar.vue?vue&type=template&id=ffbaa792&"
import script from "./ChatAppBar.vue?vue&type=script&lang=js&"
export * from "./ChatAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports